import { render, staticRenderFns } from "./PromotionType.vue?vue&type=template&id=6b1e59fc"
import script from "./PromotionType.vue?vue&type=script&lang=js"
export * from "./PromotionType.vue?vue&type=script&lang=js"
import style0 from "./PromotionType.vue?vue&type=style&index=0&id=6b1e59fc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports